module.exports = __webpack_public_path__ + "img/202-2a7c08.png";